import React, { useState, useEffect } from "react";
import Tour from "reactour";
import { Button, useTheme } from "@mui/material";

const FilterModelTutorial = ({
  isOpen,
  setIsOpen,
  isFilterModelManagerOpen,
  closeFilterModelManager,
}) => {
  const theme = useTheme();
  const [isTourOpen, setIsTourOpen] = useState(isOpen);
  const [currentStep, setCurrentStep] = useState(0);
  const [hasSetStep, setHasSetStep] = useState(0);
  const [step, setStep] = useState(undefined);

  useEffect(() => {
    setHasSetStep(false);
    setIsTourOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (currentStep === 0 && isFilterModelManagerOpen && !hasSetStep) {
      setStep(1);
      setHasSetStep(true);
    } else {
      setStep(undefined);
    }
  }, [currentStep, isFilterModelManagerOpen]);

  const steps = [
    {
      selector: ".filter-model-button",
      content:
        "Welcome to the new Filter Model Manager - Click this button to get started",
    },
    {
      selector: ".MuiDialog-paper",
      content:
        "This is the Filter Model Manager. Here you can create, edit, and manage your filter models.",
    },
    {
      selector: ".MuiDialog-paper input:first-of-type",
      content: "Enter a name for your new filter model here.",
    },
    {
      selector: ".MuiList-root",
      content:
        "This list shows all your saved filter models. You can drag and drop to reorder them.",
    },
    {
      selector: ".MuiListItemButton-root:first-of-type",
      content:
        "Click on a filter model to select it. You can also edit, duplicate, or delete models using these buttons.",
    },
    {
      selector: ".MuiDialogActions-root",
      content:
        "Use these buttons to save a new model, update the current one, or deselect the filter.",
    },
    {
      selector: "body",
      content:
        "That's it! You now know how to use the Filter Model Manager. Happy filtering!",
    },
  ];

  const closeTour = () => {
    setIsTourOpen(false);
    setIsOpen(false);
    closeFilterModelManager();
    localStorage.setItem("hasSeenFilterModelTutorial", "true");
  };

  return (
    <>
      <Tour
        steps={steps}
        isOpen={isTourOpen}
        onRequestClose={closeTour}
        getCurrentStep={(curr) => setCurrentStep(curr)}
        goToStep={step}
        rounded={8}
        accentColor={theme.palette.primary.main}
        className="filter-model-tutorial"
        closeWithMask={false}
        lastStepNextButton={<Button onClick={closeTour}>Finish</Button>}
        // nextButton={
        //   currentStep === 1 && !isFilterModelManagerOpen ? <></> : undefined
        // }
        // prevButton={
        //   currentStep === 1 && !isFilterModelManagerOpen ? <></> : undefined
        // }
        disableKeyboardNavigation={
          currentStep === 0 && !isFilterModelManagerOpen
        }
        disableDotsNavigation={currentStep === 0 && !isFilterModelManagerOpen}
        showButtons={!(currentStep === 0 && !isFilterModelManagerOpen)}
      />
      <Button
        onClick={() => {
          setIsTourOpen(true);
        }}
        sx={{
          position: "fixed",
          bottom: 20,
          left: 20,
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
          },
          zIndex: 1000,
        }}
      >
        Start Tutorial
      </Button>
    </>
  );
};

export default FilterModelTutorial;
